/**
 * VNS clinics.
 *
 * Hardcoded allowlist of clinic IDs that belong to VNS. Currently a single
 * clinic; extend the list as more VNS facilities are onboarded.
 *
 * Used to relax Documentation-tab (BillingModule) behaviour for VNS:
 *   - Billing Practitioners see every patient row regardless of consent
 *     status (`enrichRowsByMonth` in `billingRowEnrichment.ts`).
 *   - "Download as CSV" includes patients regardless of consent status
 *     (`buildSingleFacilityCsvRows` in `billingCsv.ts`).
 *   - "Download as PDF" includes patients regardless of consent status
 *     (`selectBillingRowsForPdf` in `billingPdfChunk.ts`).
 */
export const VNS_CLINIC_IDS: readonly number[] = [11161];

export const isVnsClinic = (clinicId?: number | null): boolean =>
  clinicId != null && VNS_CLINIC_IDS.includes(clinicId);
